// hooks/useStripePromise.ts
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadStripe, Stripe } from '@stripe/stripe-js';
import { getPublishableKey } from '../redux/payment/action';
import { publishableKeySelector } from '../pages/EsSettings/selector';

export const useStripePromise = (): Promise<Stripe | null> | null => {
    const dispatch = useDispatch();
    const { publishableKey } = useSelector(publishableKeySelector);

    useEffect(() => {
        if (!publishableKey) {
            dispatch(getPublishableKey({ source: 'stripe' }));
        }
    }, [dispatch, publishableKey]);

    const stripePromise = useMemo(() => {
        if (publishableKey) {
            return loadStripe(publishableKey!);
        }
        return null;
    }, [publishableKey]);

    return stripePromise;
};
